import React, {Component} from 'react';
import { getClassNames } from 'dynamic-class-list';
import { DropTarget } from 'react-dnd';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import { update_drop_target, update_active, getHoverType, getTargetType } from '../../Services/Drop/action';
import { addDragEmelements } from '../../Services/Drag/action';
import { Store } from '../../../src/store';
import {Types} from '../../Services/Types';
import {checkingDropElementsRight} from '../../Services/Global/action';


export const ItemTypes = {
    CARD: 'card'
};

function collect(connect, monitor) {
    return {
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      getItem: monitor.getItem(),
    };
}

const squareTarget = {
    drop(props, monitor, component ) {
        let item = monitor.getItem();
        console.log(props);
        Store.dispatch(update_drop_target(item.type, props.mainIndex, props.childIndex));
        Store.dispatch(getTargetType(item.type, props.mainTarget.types));
        
        let insertData = {
            'mainIndex': props.mainIndex,
            'childIndex': props.childIndex,
            'type': item.type,
            'rotation': 'top'
        };

        Store.dispatch(addDragEmelements(insertData));
    },
    canDrop(props, monitor, component) {
        const stateObj = Store.getState();
        let elements = stateObj.drop.droplEments;
        let item = monitor.getItem();
        // return checkingDropElementsRight(elements, props.mainIndex, item)
        return true;
        
    },
};

class DropzoneColumnRight extends Component {
    constructor(props, context) {
		super(props, context);

        this.state = {
        }
    }

    render = () => {
        const {connectDropTarget, isOver, canDrop, getItem, mainTarget, targethover} = this.props;

        let appendTarget = "";
        
        if(mainTarget.item)
        {
            
            switch(mainTarget.item) {
                case Types.ONE: 
                    appendTarget = <div className="rightline" style={{height: "160px", marginTop: '-3px'}}></div> 
                break;
                case Types.TWO: 
                    appendTarget = <div className="rightline" style={{height: "160px"}}></div>   
                break;
                case Types.THREE: 
                    appendTarget = <div className="rightline" style={{height: "80px"}}></div>  
                break;
                case Types.FOUR: 
                appendTarget = <div className="rightline" style={{height: "80px"}}></div> 
                break;  
                default: 

            }
            
        }
        if(isOver && canDrop)
        {
            var dropZonesStyle = getClassNames({
                'right': function() {
                    return true
                },
                'over': function() {
                    return true;
                },
                'right-2': function() {
                    
                    switch(getItem.type)
                    {
                        case Types.ONE:
                            return true;
                        case Types.TWO:
                            return true;
                        default: 
                            return false;
                    }
                },
            });
        } else if(isOver && !canDrop) {
            var dropZonesStyle = getClassNames({
                'right': function() {
                    return true
                },
                'right-2': function() { 
                    switch(getItem.type)
                    {
                        case Types.ONE:
                            return true;
                        case Types.TWO:
                            return true;
                        default: 
                            return false;
                    }
                },
                'red': function() {
                    return true;
                }
            });
        }else {
            var dropZonesStyle = getClassNames({
                'right': function() {
                    return true
                },
                'over': function() {
                    return false;
                },
                'has-text-centered': function() {
                    return true;
                }
            });
        }
        return connectDropTarget (
            <div className={dropZonesStyle}>{appendTarget}</div>
        )
    }
}


DropzoneColumnRight = DropTarget(ItemTypes.CARD, squareTarget, collect)(DropzoneColumnRight);
const mapStateToProps = (state) => {
    return {
        dropElements: state.drop.droplEments,
        targethover: state.drop.targethover
    };
};
const mapDispatchToProps = (dispatch) => {
  return {
    update_drop_target: bindActionCreators(update_drop_target, dispatch),
    update_active: bindActionCreators(update_active, dispatch),
    getHoverType: bindActionCreators(getHoverType, dispatch),
    getTargetType: bindActionCreators(getTargetType, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DropzoneColumnRight);


// WEBPACK FOOTER //
// ./src/Components/DropzoneColumnRight/index.js